import React, { Component } from "react";
import NavigationDrawer from "react-md/lib/NavigationDrawers";
import Button from "react-md/lib/Buttons";
import Link from "gatsby-link";
import Footer from "../Footer/Footer";
import GetNavList from "./NavList";
import SiteData from "../../../data/SiteData";
import "./Navigation.scss";

const actions = (
  <div className="toolbar-actions">
    <div className="nav-container">
      <Link to="/">
        <Button flat secondary label="Home" />
      </Link>
      <Link to="/community">
        <Button flat secondary label="Community" />
      </Link>
      <Link to="/contact">
        <Button flat secondary label="Contact Us" />
      </Link>
    </div>
  </div>
);

class Navigation extends Component {
  render() {
    const { children, localTitle } = this.props;
    return (
      <NavigationDrawer
        toolbarTitle={localTitle}
        drawerTitle={SiteData.title}
        contentClassName="main-content"
        navItems={GetNavList()}
        mobileDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
        tabletDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
        desktopDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
        toolbarActions={actions}
        toolbarThemeType="themed"
      >
        <div className="main-container md-grid--no-spacing md-cell--middle">
          {children}
        </div>
        <Footer />
      </NavigationDrawer>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.jsx